/**
 * Склонение слова после числа
 * @param {number} number — число
 * @param {[string, string, string]} forms — массив из 3 форм: ['игра', 'игры', 'игр']
 *
 * @returns {string} — строка с подходящей формой слова к числу
 */
export const pluralize = (number, forms) => {
    const lastTwoDigits = Math.abs(number) % 100;
    const lastDigit = lastTwoDigits % 10;

    if (lastTwoDigits > 10 && lastTwoDigits < 20) {return forms[2]}
    if (lastDigit > 1 && lastDigit < 5) {return forms[1]}
    if (lastDigit === 1) {return forms[0]}

    return forms[2];
}